import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem6xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import { 
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import parentescoList from '../../../business-rules/List/parentescoList'

import tipoRegimeBensList from '../../../business-rules/List/tipoRegimeBensList'

import tipoEstadoCivilList from '../../../business-rules/List/tipoEstadoCivilList'

import familiaresList from '../../../business-rules/List/familiaresList'

import CadastroFormContato from './CadastroFormContato'

import {
    ButtonIncluirLinha
 } from '../../../business-components/Button/Button'

import {
    incrementaContFamiliar,
} from './CadastroServiceFamiliares'

import {
    NomeFamiliar,
    IconButtonClearEntradaDadosFamiliar,
    NascimentoFamiliar,
    IdadeFamiliar,
    SexoFamiliar,
    ParentescoFamiliar,
    NomeCurtoFamiliar,
    CpfFamiliar,
    HerancaFamiliar,
    AvatarFamiliar,
} from '../cadastro-form/CadastroCompFamiliares'

import CadastroFormContaInvestimentos from './CadastroFormContaInvestimentos'



const CadastroFormFamiliares = ({ values, handleChange, handleSubmit, setFieldValue }) => {

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <FieldArray name="familiares">
                {(arrayHelpers) => (
                    <DivForm>
                        <DivForm
                            style={{
                                display: values.familiares && values.familiares.length > 0 ? "block" : "none"
                            }}
                        >
                            <GridContainer>
                                {values.familiares?.map((item, ind) => {

                                    const geracaoFamiliar =
                                        pesquisaList(parentescoList(true), item.parentescoFamiliar).geracao

                                    return (
                                        <GridItem6xs12
                                            key={ind}
                                        >
                                            <CardGridEntradaDados>
                                                <CardGridDivHeaderEntradaDados>
                                                    <GridContainer>
                                                        <NomeFamiliar
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                        />
                                                        <IconButtonClearEntradaDadosFamiliar
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            arrayHelpers={arrayHelpers}
                                                        />
                                                    </GridContainer>
                                                </CardGridDivHeaderEntradaDados>

                                                <CardGridDivBodyEntradaDados>
                                                    <GridContainer>
                                                        <NascimentoFamiliar
                                                            item={item}
                                                            ind={ind}
                                                            setFieldValue={setFieldValue}
                                                        />

                                                        <IdadeFamiliar
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                        />

                                                        <SexoFamiliar
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                        />

                                                        <ParentescoFamiliar
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridContainer>

                                                    <GridContainer>
                                                        <NomeCurtoFamiliar
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                        />

                                                        <CpfFamiliar
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridContainer>

                                                    <HerancaFamiliar
                                                        values={values}
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                    />

                                                    {geracaoFamiliar === HARDCODE.geracao2 && (
                                                        <>
                                                            <CardGridDividerElementos/>

                                                            <GridContainer>
                                                                <GridItem6xs12>
                                                                    <TextFieldTextSelect
                                                                        name={`familiares[${ind}].tipoRegimeBensGeracao2`}
                                                                        label={LABEL.tipoRegimeBens}
                                                                        value={item.tipoRegimeBensGeracao2 || ''}
                                                                        onChange={handleChange}
                                                                        list={tipoRegimeBensList}
                                                                    />
                                                                </GridItem6xs12>

                                                                <GridItem6xs12>
                                                                    <TextFieldTextSelect
                                                                        name={`familiares[${ind}].estadoCivilGeracao2`}
                                                                        label={LABEL.estadoCivil}
                                                                        value={item.estadoCivilGeracao2 || ''}
                                                                        onChange={handleChange}
                                                                        list={tipoEstadoCivilList}
                                                                    />
                                                                </GridItem6xs12>
                                                            </GridContainer>
                                                        </>
                                                    )}

                                                    {geracaoFamiliar === HARDCODE.geracao3 && (
                                                        <>
                                                            <CardGridDividerElementos/>

                                                            <GridContainer>
                                                                <GridItem6xs12>
                                                                    <TextFieldNumberSelect
                                                                        name={`familiares[${ind}].idFamiliarGeracao2`}
                                                                        label={LABEL.familiarGeracao2}
                                                                        value={item.idFamiliarGeracao2 || ''}
                                                                        onChange={handleChange}
                                                                        list={
                                                                            familiaresList(values).filter(
                                                                                familiar => familiar.geracao ===
                                                                                    HARDCODE.geracao2)
                                                                        }
                                                                    />
                                                                </GridItem6xs12>
                                                            </GridContainer>
                                                        </>
                                                    )}

                                                    <CardGridDividerElementos/>

                                                    <GridContainer>
                                                        <GridItem12>
                                                            <TextValidatorText
                                                                name={`familiares[${ind}].observacaoFamiliar`}
                                                                label={LABEL.observacao}
                                                                value={item.observacaoFamiliar || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.observacao}
                                                            />
                                                        </GridItem12>
                                                    </GridContainer>

                                                    <CardGridDividerElementos/>

                                                    <CadastroFormContato
                                                        familiar={item.familiar}
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />

                                                    <CardGridDividerElementos/>

                                                    <CadastroFormContaInvestimentos
                                                        familiar={item.familiar}
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />

                                                    <CardGridDividerElementos/>
                                                    
                                                    <AvatarFamiliar
                                                        item={item}
                                                        ind={ind}
                                                        setFieldValue={setFieldValue}
                                                    /> 
                                                </CardGridDivBodyEntradaDados>
                                            </CardGridEntradaDados>
                                        </GridItem6xs12>
                                    )
                                })}
                            </GridContainer>
                        </DivForm>

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirFamiliar} 
                            onClick={() => 
                                {
                                    incrementaContFamiliar(values)
                                    arrayHelpers.push({
                                        familiar: values.contFamiliar,
                                        nascimentoFamiliar: null,
                                    })
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </ValidatorFormPadrao>
    )
}

export default CadastroFormFamiliares